import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/api/queryClient';

interface QueryProviderProps {
  children: React.ReactNode;
}

/**
 * QueryProvider wraps the app with React Query's QueryClientProvider
 * This enables all API hooks throughout the application
 */
export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

export default QueryProvider;

